import { client } from '@/shared/api';
const PATH_AUTH_API = 'Admin';
// Выпадающему списку нужны все цепочки сразу, а не первая страница.
const CHAIN_DESCRIPTIONS_PAGE_SIZE = 1000;
// Имена query-параметров бэкенда; те же имена используются в адресной строке страницы.
export const FILTER_PARAMS = {
    eventCodeContains: 'event-code-contains',
    chainTypeCode: 'chain-type-code',
    chainTypeCodeContains: 'chain-type-code-contains',
    chainTypeDescriptionContains: 'chain-type-description-contains',
    eventLinkDescriptionContains: 'event-link-description-contains',
    enabled: 'enabled',
};
const FILTER_KEYS = Object.keys(FILTER_PARAMS);
// Пустые значения не отправляем - бэкенд трактует отсутствие параметра как "без фильтра".
export const serializeFilters = (filters) => {
    const params = {};
    FILTER_KEYS.forEach((key) => {
        const value = filters[key];
        if (value !== undefined && value !== '') {
            params[FILTER_PARAMS[key]] = String(value);
        }
    });
    return params;
};
export const parseFilters = (params) => {
    const filters = {};
    FILTER_KEYS.forEach((key) => {
        const value = params.get(FILTER_PARAMS[key])?.trim();
        if (!value) {
            return;
        }
        if (key === 'enabled') {
            // Прочие значения из адресной строки игнорируем.
            if (value === 'true' || value === 'false') {
                filters.enabled = value === 'true';
            }
            return;
        }
        filters[key] = value;
    });
    return filters;
};
// Интерцептор client возвращает ошибку вместо reject, поэтому data может отсутствовать.
export const getEventChainLinks = async ({ pageSize, pageNumber, ...filters }) => {
    const { data } = await client.get(`${PATH_AUTH_API}/EventChainLinks`, {
        params: { PageSize: pageSize, PageNumber: pageNumber, ...serializeFilters(filters) },
    });
    if (!data?.links) {
        throw new Error('EventChainLinks. Не удалось загрузить события связи');
    }
    return data;
};
export const getChainDescriptions = async () => {
    const { data } = await client.get(`${PATH_AUTH_API}/GetIntegrationChainDescriptionList`, {
        params: { pageSize: CHAIN_DESCRIPTIONS_PAGE_SIZE, pageNumber: 1 },
    });
    if (!data?.isSuccess) {
        throw new Error(`GetIntegrationChainDescriptionList. ${data?.errorMessage ?? ''}`);
    }
    return data;
};
export const updateEventChainLink = async ({ guid, ...body }) => {
    const { data } = await client.patch(`${PATH_AUTH_API}/EventChainLinks/${guid}`, body, { headers: { 'Content-Type': 'application/json-patch+json' } });
    if (!data?.updated) {
        throw new Error('UpdateEventChainLink. Событие связи не обновлено');
    }
    return data;
};
export const deleteEventChainLink = async (guid) => {
    const { data } = await client.delete(`${PATH_AUTH_API}/EventChainLinks/${guid}`);
    if (!data?.deleted) {
        throw new Error('DeleteEventChainLink. Событие связи не удалено');
    }
    return data;
};
export const createEventChainLink = async (config) => {
    const { data } = await client.post(`${PATH_AUTH_API}/EventChainLinks`, config, {
        headers: { 'Content-Type': 'application/json-patch+json' },
    });
    if (!data?.data) {
        throw new Error('CreateEventChainLink. Событие связи не создано');
    }
    return data;
};
